import { normalizarRut } from "./rut";
import { client } from "./supabase";

// Nombre a MOSTRAR de un proveedor (regla 10.1 — fallback centralizado). Devuelve el `alias`
// (nombre de fantasía, ej. "SendGrid" para "Twilio SendGrid") si está poblado, o el `nombre`
// formal (razón social) si no. El `.trim()` hace que un alias "" (cadena vacía, no null) caiga
// al nombre formal. SOLO para display — el matching/comparación es siempre por ID (regla 10.7),
// nunca por este valor. El `nombre` formal y los snapshots persistidos no se tocan.
export const getNombreProveedor = (prov) => prov?.alias?.trim() || prov?.nombre || "";

// Un proveedor por ID (regla 10.7 — lookup por id, nunca por nombre). Devuelve null si no existe.
export const getProveedorPorId = async (id) => {
  if (!id) return null;
  const { data, error } = await client.from("proveedores").select("*").eq("id", id).maybeSingle();
  if (error) throw error;
  return data || null;
};

export const getProveedores = async (pais, soloHabilitados = true) => {
  let query = client.from("proveedores").select("*").eq("pais", pais);
  if (soloHabilitados) query = query.eq("habilitado", true);
  query = query.order("nombre", { ascending: true });
  const { data, error } = await query;
  if (error) throw error;
  return data || [];
};

// Crea un proveedor con guard anti-duplicado por RUT (regla 10.7). Como los `rut_ruc`
// guardados están en formatos heterogéneos (con/sin puntos, guión Unicode −, sin DV), la
// comparación se hace NORMALIZADA en memoria, no con un `.eq` a la columna cruda. Scope por país
// (el RUT es una clave nacional). Extranjeros sin `rut_ruc` se insertan sin guard.
//
// Retorno:
//   - éxito → la fila creada (tiene `.id`).
//   - duplicado → `{ yaExiste: true, proveedor: { id, nombre, rut_ruc } }` (NO inserta).
export const crearProveedor = async (proveedorData) => {
  const rutNuevo = normalizarRut(proveedorData?.rut_ruc);
  if (rutNuevo) {
    let query = client.from("proveedores").select("id, nombre, rut_ruc").not("rut_ruc", "is", null);
    if (proveedorData?.pais) query = query.eq("pais", proveedorData.pais);
    const { data: existentes, error: errBusca } = await query;
    if (errBusca) throw errBusca;
    const dup = (existentes || []).find((p) => normalizarRut(p.rut_ruc) === rutNuevo);
    if (dup) return { yaExiste: true, proveedor: dup };
  }
  const { data, error } = await client.from("proveedores").insert([proveedorData]).select();
  if (error) throw error;
  return data?.[0];
};

export const actualizarProveedor = async (id, proveedorData) => {
  const { data, error } = await client
    .from("proveedores")
    .update({ ...proveedorData, updated_at: new Date().toISOString() })
    .eq("id", id)
    .select();
  if (error) throw error;
  return data?.[0];
};
